import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Form1118SyncService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following service pattern exactly
  initiate1118Sync(
    pdfEngineApiUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction without query string parameters
    const url = `${pdfEngineApiUrl}/initiate1118Sync`;

    // 🚀 CRITICAL: Build form data from params
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        if (Array.isArray(params[key]) || typeof params[key] === 'object') {
          urlEncoded.set(key, JSON.stringify(params[key]));
        } else {
          urlEncoded.set(key, params[key].toString());
        }
      }
    });

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    // Send params in request body
    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}







